export function substituterHandler({ item, current, formattedSubstitution }) {
  const updatedCustomisations =
    item?.type === 'customise' &&
    item?.customisations?.map(customisation => {
      if (customisation?.type === 'substitutable') {
        return {
          ...customisation,
          products: customisation?.products?.map(product => {
            if (product?.id === current?.id) {
              return {
                ...formattedSubstitution,
                count: product.count || { min: 0, max: 0, current: 0, initial: 0 },
                selected: product.selected,
              };
            }
            return product;
          }),
        };
      }
      return customisation;
    });
  const updatedOptions =
    item?.type === 'combo' &&
    item?.options?.map(option => {
      if (
        option?.products?.some(product =>
          product?.customisations?.some(customisation =>
            customisation?.products?.some(innerProduct => innerProduct?.id === current?.id),
          ),
        )
      ) {
        return {
          ...option,
          products: option?.products?.map(product => ({
            ...product,
            customisations: product?.customisations?.map(customisation => ({
              ...customisation,
              products: customisation?.products?.map(innerProduct => {
                if (innerProduct?.id === current?.id) {
                  return {
                    ...formattedSubstitution,
                    count: innerProduct.count || { min: 0, max: 0, current: 0, initial: 0 },
                    selected: true,
                  };
                }
                return { ...innerProduct, selected: false };
              }),
            })),
          })),
        };
      }
      return option;
    });
  return {
    ...item,
    ...(updatedCustomisations && { customisations: updatedCustomisations }),
    ...(updatedOptions && { options: updatedOptions }),
  };
}
